import React from 'react';

const SvgHopPhone = ({ title, ...props }) => (
  <svg width={59} height={98.719} {...props}>
    {title ? <title>{title}</title> : null}
    <g data-name="Group 636">
      <g data-name="Group 631">
        <path
          data-name="Rectangle 312"
          fill="#cc511e"
          d="M50.875 6.082l4.219-4.219 1.992 1.992-4.22 4.219z"
        />
        <path
          data-name="Rectangle 313"
          fill="#cc511e"
          d="M1.91 94.86l4.219-4.219 1.992 1.992-4.22 4.219z"
        />
        <rect
          data-name="Rectangle 314"
          width={57.072}
          height={96.791}
          rx={3.143}
          transform="translate(1.928 1.928)"
          fill="#cc511e"
        />
        <rect
          data-name="Rectangle 315"
          width={57.072}
          height={96.791}
          rx={3.143}
          fill="#f63"
        />
        <path
          data-name="Rectangle 316"
          d="M4.814 3.253h47.492a1.8 1.8 0 011.8 1.8v78.626a1.8 1.8 0 01-1.8 1.8H4.765a1.8 1.8 0 01-1.8-1.8V5.102a1.849 1.849 0 011.849-1.849z"
          fill="#270089"
        />
        <circle
          data-name="Ellipse 110"
          cx={3.406}
          cy={3.406}
          r={3.406}
          transform="translate(25.13 87.472)"
          fill="#3b3b3b"
        />
      </g>
      <g data-name="Group 635">
        <g data-name="Group 634">
          <g data-name="Group 632">
            <path
              data-name="Path 908"
              d="M49.886 28.694h-42.7a1.346 1.346 0 00-1.345 1.345v3.176h45.39v-3.176a1.346 1.346 0 00-1.345-1.345z"
              fill="#fff"
            />
          </g>
          <path
            data-name="Path 909"
            d="M5.841 33.215v22.711a1.346 1.346 0 001.345 1.345h42.7a1.346 1.346 0 001.345-1.345V33.215z"
            fill="#270089"
          />
          <g data-name="Group 633">
            <path
              data-name="Path 910"
              d="M32.531 50.248s-7.36-3.931-17.585.048c0 0 12.044-1.914 17.585 3.514z"
              fill="#ff6b00"
            />
            <path
              data-name="Path 911"
              d="M26.346 47.86a23.119 23.119 0 013.933.684 4.2 4.2 0 003.326-4.161 4.534 4.534 0 00-9.055 0 4.125 4.125 0 001.796 3.477zm2.87-5.554a2.105 2.105 0 11-2.1 2.1 2.105 2.105 0 012.099-2.1z"
              fill="#fff"
            />
            <path
              data-name="Path 912"
              d="M19.15 48.271v-3.585c0-1.568.663-2.263 1.666-2.263a1.434 1.434 0 011.408 1.6v3.81q.989-.081 1.977-.081c.2 0 .4 0 .592.008v-4.286a3.082 3.082 0 00-3.137-3.381 3.382 3.382 0 00-2.507 1.02v-5.6h-2.585v13.42q1.286-.395 2.586-.662z"
              fill="#fff"
            />
            <path
              data-name="Path 913"
              d="M38.108 40.321a5.552 5.552 0 00-2.09.407v-.64h-2.584v13.718h2.584v-5.518a4.968 4.968 0 001.973.4 4.31 4.31 0 004.513-4.3c-.002-2.56-1.94-4.067-4.396-4.067zm.006 6.2a2.1 2.1 0 01-2.1-1.939v-.342a2.1 2.1 0 112.1 2.273z"
              fill="#fff"
            />
          </g>
        </g>
        <g
          data-name="Rectangle 317"
          transform="translate(5.843 28.694)"
          fill="none"
          stroke="#fff"
          strokeMiterlimit={10}
          strokeWidth={0.277}
        >
          <rect width={45.387} height={28.577} rx={0.645} stroke="none" />
          <rect x={0.139} y={0.139} width={45.11} height={28.3} rx={0.506} />
        </g>
      </g>
    </g>
  </svg>
);

export default SvgHopPhone;
